import { registerDialog } from '@/utils/dialogAccessibility';

const dialogs = new WeakMap();
function update(element, binding) {
  const options = binding.value || {};
  const current = dialogs.get(element);
  if (options.enabled === false) {
    if (current) current.release();
    dialogs.delete(element);
  } else if (current) current.update(options);
  else dialogs.set(element, registerDialog(element, options));
}
export default {
  inserted: update,
  componentUpdated: update,
  unbind(element) {
    const current = dialogs.get(element);
    if (current) current.release();
    dialogs.delete(element);
  },
};
